import React from 'react'
import { FormLabel, Stack, StackProps } from '@mui/material'

interface FormProps extends StackProps {
  formLabelHeader: string
}

function FormInputDetailsStack(props: FormProps) {
  const { formLabelHeader, children } = props
  return (
    <Stack>
      <FormLabel className='formSmallLabel'>{formLabelHeader}</FormLabel>
      {children}
    </Stack>
  )
}

export default FormInputDetailsStack
